import script from "./VerifyEmailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyEmailPage.vue?vue&type=script&setup=true&lang=js"

import "./VerifyEmailPage.vue?vue&type=style&index=0&id=c24e4c92&lang=scss"

const __exports__ = script;

export default __exports__